<template lang="html">
  <div class="container-fluid p-1 p-lg-5 mt-3">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h6>
              <button class="back-btn" type="button" @click="back()">
                <i class="fas fa-arrow-left"></i>
              </button>
              Edit Promotion
            </h6>
          </div>

          <div class="card-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Ticket Name <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="promoRequest.ticket_name"
                />
                <small class="text-danger">{{
                  validationData.ticket_name
                }}</small>
              </div>

              <div class="form-group">
                <label>Description <span class="text-danger">*</span></label>
                <vue-editor v-model="promoRequest.decription" />
                <small class="text-danger">{{
                  validationData.decription
                }}</small>
              </div>

              <div class="form-group">
                <label>Type <span class="text-danger">*</span></label>
                <select class="form-control" v-model="promoRequest.type">
                  <option disabled value="">Select Type</option>
                  <option value="Both">Both</option>
                 <option value="Accumulator">Accumulator</option>
                  <option value="Handicap">Handicap</option>
                </select>
                <small class="text-danger">{{ validationData.type }}</small>
              </div>

              <div class="form-group">
                <label>Value Type <span class="text-danger">*</span></label>
                <select class="form-control" v-model="promoRequest.value_type">
                  <option disabled value="">Select Value Type</option>
                  <option value="Fix">Fix</option>
                  <option value="Percentage">Percent</option>
                </select>
                <small class="text-danger">{{
                  validationData.value_type
                }}</small>
              </div>

              <div class="form-group">
                <label>Value <span class="text-danger">*</span></label>
                <input
                  type="number"
                  class="form-control"
                  v-model="promoRequest.value"
                />
                <small class="text-danger">{{ validationData.value }}</small>
              </div>

              <div class="form-group">
                <label>Expired Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="promoRequest.expired_at"
                />
              </div>

              <div class="form-group">
                <label>Status</label><br />
                <label class="switch">
                  <input type="checkbox" v-model="promoRequest.status" />
                  <span class="slider"></span>
                </label>
                <small class="text-muted">
                  {{ promoRequest.status ? "Active" : "Inactive" }}
                </small>
              </div>

              <small class="text-danger">{{
                validationData.serverError
              }}</small>

              <button type="submit" class="btn btn-primary float-save">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "promotionEdit",
  components: { Loading },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      promoRequest: {
        id: "",
        ticket_name: "",
        decription: "",
        type: "",
        value_type: "",
        value: "",
        status: false,
        expired_at: ""
      },
      validationData: {
        ticket_name: "",
        decription: "",
        type: "",
        value_type: "",
        value: "",
        serverError: ""
      }
    };
  },

  methods: {
    ...mapActions({
      promoEditAction: "promotionEditAction",
      promoDetailAction: "promotionDetailAction"
    }),

    async getDetails() {
      let option = { id: this.promoRequest.id };

      await this.promoDetailAction({ ...option })
        .then((res) => {
          const d = res.data.expired_at ? new Date(res.data.expired_at) : null;
          this.promoRequest.ticket_name = res.data.ticket_name;
          this.promoRequest.decription = res.data.decription;
          this.promoRequest.type = res.data.type;
          this.promoRequest.value_type = res.data.value_type;
          this.promoRequest.value = res.data.value;
          this.promoRequest.status = res.data.status;
           this.promoRequest.expired_at = d
        ? d.toISOString().slice(0, 10)
        : "";
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
    },

    async onSubmit() {
      this.isLoading = true;

      let validation = this.validationRule();
      if (validation === true) {
        this.isLoading = false;
        return;
      }

      const formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("id", this.promoRequest.id);
      formData.append("ticket_name", this.promoRequest.ticket_name);
      formData.append("decription", this.promoRequest.decription);
      formData.append("type", this.promoRequest.type);
      formData.append("value_type", this.promoRequest.value_type);
      formData.append("value", this.promoRequest.value);
      formData.append("expired_at", this.promoRequest.expired_at ?? "");
      formData.append("status", this.promoRequest.status ? 1 : 0);

      await this.promoEditAction(formData)
        .then((res) => {
          if (res.success === true) {
            this.back();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.validationData.serverError = res.message;
            setTimeout(() => (this.validationData.serverError = ""), 3000);
          }
        })
        .catch(() => (this.isLoading = false));
    },

    back() {
      this.$router.replace({
        path: "promotion-list",
        query: { page: 1, orderBy: "asc", sortKey: "created_at" }
      }).catch(() => {});
    },

    validationRule() {
      let isError = [];

      if (!this.promoRequest.ticket_name) {
        this.validationData.ticket_name = "Ticket name is required.";
        isError.push(true);
      } else this.validationData.ticket_name = "";

      if (!this.promoRequest.decription) {
        this.validationData.decription = "Description is required.";
        isError.push(true);
      } else this.validationData.decription = "";

      if (!this.promoRequest.type) {
        this.validationData.type = "Please select type.";
        isError.push(true);
      } else this.validationData.type = "";

      if (!this.promoRequest.value_type) {
        this.validationData.value_type = "Please select value type.";
        isError.push(true);
      } else this.validationData.value_type = "";

      if (!this.promoRequest.value) {
        this.validationData.value = "Value field is required.";
        isError.push(true);
      } else this.validationData.value = "";

      return isError.includes(true);
    }
  },

  async mounted() {
    this.promoRequest.id = this.$route.query.id;
    this.getDetails();
  }
};
</script>

<style scoped lang="scss">
.float-save {
  float: right;
}
.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ccc;
  border-radius: 30px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
}
input:checked + .slider {
  background: #007bff;
}
input:checked + .slider:before {
  transform: translateX(20px);
}
</style>
